/**
 * Samlefaktura via Convene (TICKET-01715).
 *
 * A samlefaktura used to be created only as an ordinary invoice (paymentMethod
 * 'invoice', status 4). Clinics that invoice through Convene could not pick it,
 * because the «Betal via Convene» button only shows on a sale with no payment
 * method yet. These helpers let the visitor card and the Alle besøk wizard create
 * the parent sale the same way for both methods:
 *
 *   invoice  -> exactly as before.
 *   convene  -> no payment method, status 0 (Pågående), no due date. The caller then
 *               POSTs the sale to /api/integrations/convene/orders/:saleId, which
 *               moves it to status 9 (Sendt til Convene). Convene issues the invoice
 *               number and the due date, so neither is allocated here — the same
 *               shape every existing Convene sale has.
 *
 * Sub-invoice linking, the fee line and the product merge are unchanged and live in
 * the callers; they do not depend on the method.
 */

export const COLLECTIVE_INVOICE_METHOD_INVOICE = 'invoice';
export const COLLECTIVE_INVOICE_METHOD_CONVENE = 'convene';

// Same gate as the «Betal via Convene» button in salePayment.js.
export function canCreateCollectiveInvoiceViaConvene(customer) {
    if (!customer) {
        return false;
    }
    const { featureFlags = {} } = customer;
    return !!featureFlags.convenePayment && !!customer.conveneConfigured;
}

export function isConveneCollectiveInvoice(method) {
    return method === COLLECTIVE_INVOICE_METHOD_CONVENE;
}

export function collectiveInvoiceSaleProps({
    method = COLLECTIVE_INVOICE_METHOD_INVOICE, visitors, saleDate, dueDate,
} = {}) {
    if (isConveneCollectiveInvoice(method)) {
        return { status: 0, visitors, saleDate };
    }
    return {
        paymentMethod: COLLECTIVE_INVOICE_METHOD_INVOICE,
        status: 4,
        visitors,
        saleDate,
        dueDate,
    };
}

export default {
    COLLECTIVE_INVOICE_METHOD_INVOICE,
    COLLECTIVE_INVOICE_METHOD_CONVENE,
    canCreateCollectiveInvoiceViaConvene,
    isConveneCollectiveInvoice,
    collectiveInvoiceSaleProps,
};
